import { capitalize } from 'lodash';

export const permissionToGroupName = (permission: string) => {
  return permission
    .replaceAll(/member:group:/g, '')
    .split('-')
    .map(capitalize)
    .join(' ');
};
